export const SYNC_TWR_DEVICES_BY_ROOMS = '@@twrDevicesByRooms/syncTwrDevicesByRooms'

export const RESET_TWR_DEVICES_BY_ROOMS = '@@twrDevicesByRooms/reset'

export const UPDATE_TWR_DEVICES_BY_ROOMS = '@@twrDevicesByRooms/updateTwrDevicesByRooms'
